import React from "react";
import CustomDropdown from "../../../Ui_Components/CustomDropdown";
import { DropdownOption } from "../../../Ui_Components/CustomDropdown";

interface FormDropdownProps {
  label: string;
  unit?: string;
  options: DropdownOption[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
  error?: string;
  searchable?: boolean;
  required?: boolean;
}

const FormDropdown: React.FC<FormDropdownProps> = ({
  label,
  unit,
  options,
  value,
  onChange,
  placeholder = "Select option",
  className = "",
  error,
  searchable = false,
  required = false,
}) => {
  return (
    <div className={`flex flex-col gap-1.5 ${className}`}>
      <label className="text-sm 3xl:text-base font-medium font-inter text-[#1F1F1F]">
        {label}
        {unit && (
          <span className="ml-1 text-xs 3xl:text-sm font-normal text-[#646464]">
            ({unit})
          </span>
        )}
        {required && <span className="text-red-500 ml-0.5">*</span>}
      </label>
      <CustomDropdown
        options={options}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        searchable={searchable}
        className={error ? "ring-1 ring-red-400 rounded-md" : ""}
      />
      {error && (
        <p className="text-xs 3xl:text-sm text-red-500 font-inter">{error}</p>
      )}
    </div>
  );
};

export default FormDropdown;
